const HeaderSection = ({ title }) => {
  return (
    <div className='text-lg font-semibold text-gray-800'>
      <h1>{title}</h1>
    </div>
  );
};

export default HeaderSection;
